<div class="flex w-full flex-col rounded-2.5 bg-gray-000 {{ containerClass() }}">
	<ui-button
		type="button"
		variant="ghost"
		size="xl"
		shape="square"
		class="w-full"
		extraButtonClasses="w-full justify-between px-4 hover:bg-transparent active:bg-transparent shadow-2xs"
		[id]="headerId"
		[attr.aria-controls]="contentId"
		[attr.aria-expanded]="expanded()"
		(clicked)="toggle()">
		<span class="flex w-full items-center justify-between">
			<span class="flex min-w-0 items-center gap-2">
				@if (iconName(); as icon) {
					<ui-icon
						width="22"
						height="22"
						class="shrink-0 text-gray-700"
						aria-hidden="true"
						[iconName]="icon" />
				}
				<span class="truncate text-3.25 font-bold text-gray-900 {{ titleClass() }}">{{ label() }}</span>
			</span>
			<ui-icon
				width="22"
				height="22"
				class="text-gray-500 transition-transform duration-300 ease-in-out"
				[iconName]="IconName.ChevronDown"
				[class.rotate-180]="expanded()" />
		</span>
	</ui-button>

	<div role="region" [id]="contentId" [class]="panelClasses()" [attr.aria-labelledby]="headerId">
		<ng-content />
	</div>
</div>
